import { TransportCatalogSearchCriteria } from '../../store/state/monitoring/transport/models/transport.model';
import { TransportManagementSearchCriteria } from '../../store/state/monitoring/transport-management/models/transport-management.model';
import { AutomotiveAftermarketSearchCriteria } from '../../store/state/monitoring/automotive-aftermarket/models';
import { AllocationViewListSearchCriteria } from '../../store';

export type CatalogSearchCriteria =
  | TransportCatalogSearchCriteria
  | TransportManagementSearchCriteria
  | AutomotiveAftermarketSearchCriteria
  | AllocationViewListSearchCriteria;
